// import { AudioList, audio } from "@/config/audio";
import { getFileFromURL } from ".";

// export type AudioName = 'breakIce';
export type AudioName = 'micro';

const audioResource: Record<AudioName, { url: string, file: AudioBuffer | null }> = {
    'micro': {
        url: 'micro.wav',
        file: null,
    },
}

async function loadAudioData(name: string) {
    const file = await getFileFromURL(name);
    const arrayBuffer = await file.arrayBuffer();
    const audioContext = new AudioContext();
    return await audioContext.decodeAudioData(arrayBuffer);
}

export async function loadAudioSource() {
    const list = Object.values(audioResource);
    for (let i = 0; i < list.length; i++) {
        const file = await loadAudioData(list[i].url);
        list[i].file = file;
    }
}

const audioCtx = new AudioContext();
export function playAudio(key: AudioName, loop = false) {
    const source = audioCtx.createBufferSource();
    const file = audioResource[key].file;
    source.buffer = file;
    source.loop = loop;
    source.connect(audioCtx.destination);
    source.start(0);
    function stop() {
        source.stop();
    }

    return { stop };
}